module.exports = __webpack_public_path__ + "themes/non-default/addeparStep2PortfolioPrefix.78f24051b282f08cafacf96739e71f0d.png";